import InternalAvatar from './avatar';
import Group from './group';
export { AvatarProps } from './avatar';
export { GroupProps } from './group';
const Avatar = InternalAvatar;
Avatar.Group = Group;
export { Group };
export default Avatar;
